import { useState } from "react";
import Boo from "./Boo/Boo";
import boo from "../../images/Boo.png";
import movieKnight from "../../images/movieKnight.png";
import MovieKnight from "./MovieKnight/MovieKnight";
import connect01 from "../../images/connect01.png";
import "./Projects.css";
import HashChat from "./HashChat/HashChat";

const Projects = () => {
  const [viewProject, setViewProject] = useState(null);
  console.log(window.innerHeight);
  return (
    <div className="Projects">
      <h2>Projects</h2>
      {!viewProject && (
        <div className="projects-views">
          <div className="project-card" onClick={() => setViewProject("boo")}>
            <img src={boo} />
            <div>
              <p>Boo</p>
            </div>{" "}
          </div>
          <div
            className="project-card"
            onClick={() => setViewProject("movieKnight")}
          >
            <img src={movieKnight} />
            <div>
              <p>MovieKnight</p>
            </div>
          </div>
          <div
            className="project-card"
            onClick={() => setViewProject("hashChat")}
          >
            <img src={connect01} />
            <div>
              <p>Connect</p>
            </div>{" "}
          </div>
        </div>
      )}
      {viewProject === "hashChat" && (
        <HashChat setViewProject={setViewProject} />
      )}
      {viewProject === "boo" && <Boo setViewProject={setViewProject} />}
      {viewProject === "movieKnight" && (
        <MovieKnight setViewProject={setViewProject} />
      )}
    </div>
  );
};

export default Projects;
